import { render, staticRenderFns } from "./MallStatusBar.vue?vue&type=template&id=71adaa70&scoped=true&"
import script from "./MallStatusBar.vue?vue&type=script&lang=ts&"
export * from "./MallStatusBar.vue?vue&type=script&lang=ts&"
import style0 from "./MallStatusBar.vue?vue&type=style&index=0&id=71adaa70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71adaa70",
  null
  
)

export default component.exports